// extracted by mini-css-extract-plugin
export default {"tabPanel":"tab-panel_tabPanel__+pNJo"};